module.exports = __webpack_public_path__ + "static/media/Bettkissen_80x60.fd877da8.png";